export interface UniswapV3AlgebraProviderConfiguration {
    readonly wethAddress: string;
    readonly maxTransitTokens: number;
}
